var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcMessage = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72673 6.95015C9.72673 7.21476 9.62162 7.46853 9.43451 7.65564C9.2474 7.84274 8.99363 7.94786 8.72902 7.94786H2.74274L0.747314 9.94329V1.96158C0.747314 1.69697 0.85243 1.4432 1.03954 1.25609C1.22665 1.06898 1.48042 0.963867 1.74503 0.963867H8.72902C8.99363 0.963867 9.2474 1.06898 9.43451 1.25609C9.62162 1.4432 9.72673 1.69697 9.72673 1.96158V6.95015Z",
    stroke: "white",
    strokeWidth: 1.06898,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcMessage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-message.63105f70.svg";
export { ForwardRef as ReactComponent };